import { render } from "./PaymentsModal.vue?vue&type=template&id=27a998a6"
import script from "./PaymentsModal.vue?vue&type=script&lang=js"
export * from "./PaymentsModal.vue?vue&type=script&lang=js"

import "./PaymentsModal.vue?vue&type=style&index=0&id=27a998a6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__